import { getSrcs } from '@helpers/image';
import { ComponentTheme } from '@helpers/themeEnum';
import SvgPathwayFallback from '@img/pathway-fallback.svg';
import { FakeButton } from '@stories/Components/Buttons/GeneralButton/Button';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import { ArticleCardStyles as S } from './ArticleCard.styles';
const ArticleCard = ({ tag, cta, image, ratio = 1.35, summary, theme = ComponentTheme.Blue, title, }) => {
    const srcs = image ? getSrcs(image, 567, 278, 4, ratio, image.focalPoint) : undefined;
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.Container, { href: cta.url, target: cta.target ?? '_self', "data-square": ratio === 1 },
            React.createElement(S.Inner, null,
                React.createElement(S.MediaHolder, null, image && image.src && srcs ? (React.createElement(S.Image, { alt: image.altText ?? '', loading: "lazy", role: image.altText ? undefined : 'presentation', src: srcs[0].split(' ')[0], srcSet: srcs.join(',') })) : (React.createElement(SvgPathwayFallback, null))),
                React.createElement(S.ContentArea, null,
                    React.createElement(S.ContentInner, null,
                        tag && React.createElement(S.Caption, null, tag),
                        React.createElement(S.Title, null, title),
                        summary && React.createElement(S.Intro, null, summary),
                        React.createElement(S.FakeButton, null,
                            React.createElement(FakeButton, { styleType: "underline", backgroundPlacement: "light", branding: theme == ComponentTheme.White ? ComponentTheme.Black : theme, buttonSize: "small", title: cta.text ?? 'Read More' }))))))));
};
export default ArticleCard;
